import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

/**
 * Thunk para buscar todos os showcases                                                 .
 */
export const fetchShowcases = createAsyncThunk(
  "showcases/fetchShowcases",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/showcase/showcases`);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: "Erro ao buscar showcases" }));
        throw new Error(errorData.message);
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

